<template>
  <section>
    <div class="row">
    
        <div class="row">
          <div class="col-md-3 form-group" style="font-size:16px!important">
            <label for="exampleInputEmail1">Please upload Image</label>
            <br />

            <input
              type="file"
              class="images"
              accept="image/*"
              id="file"
              ref="file"
              v-on:change="handleFileUpload()"
            />
          </div>
          <div class="col-md-2">
            <div width="80px" height="80px" id="preview">
              <img width="100%" height="100%" :src="image" />
            </div>
          </div>
        </div>
        <hr />
        <button @click="uploadImage()" type="submit" class="pt-2 pb-2 btn btn-success" style="width:100%!important;">Submit</button>
     
    </div>
  </section>
</template>
<script>
import axios from "axios";
export default {
  data: () => {
    return {
      image: null,
      file: "",
      loading: false,
    };
  },

  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.image = URL.createObjectURL(this.file);
    },
    uploadImage() {
      var data = new FormData();
      console.log(data)
      data.append("id", "5f6067b6528d8e1b60f31b09");
      data.append("photo", 'dthyfugk');
      for(var pair of data.entries()) {
   console.log(pair[0]+ ', '+ pair[1]); 
}

      axios({
        method: "POST",
         url: "/user/imageupload",
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
        data: data,
        onUploadProgress: function (progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          vm.uploadMsg = "Uploading " + percentCompleted + "%";
          // if (percentCompleted == 100) vm.uploadMsg = "";
        },
      })
        .then((response) => {
          alert("User Details edited Successfully");
        //   this.$router.push({ path: "/Userlist" });
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          this.error = e.response.data.msg;
          alert("User Details edited Successfully");
        });
    },
  },
};
</script>

<style >
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}

.btn.btn-sm,
.btn-group-sm > .btn {
  display: none !important;
}
#myMap {
  height: 400px !important;
  width: 100%;
}
</style>